import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "sticky top-0 z-20 bg-white border-b border-gray-200 shadow-sm" }
const _hoisted_2 = { class: "max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-start gap-4" }
const _hoisted_3 = { class: "flex-1 min-w-0 grid grid-cols-1 sm:grid-cols-2 gap-3" }
const _hoisted_4 = { class: "flex items-center gap-2 shrink-0 mt-1" }
const _hoisted_5 = { class: "flex items-center gap-2 cursor-pointer px-3 py-2 border border-gray-200 rounded-lg" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "w-4 h-4 border-2 border-white/40 border-t-white rounded-full animate-spin"
}
const _hoisted_8 = { class: "max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8 py-6" }
const _hoisted_9 = {
  key: 0,
  class: "flex items-center justify-center py-16"
}
const _hoisted_10 = { class: "bg-white border border-gray-200 rounded-xl shadow-sm mb-6" }
const _hoisted_11 = { class: "px-5 py-3 border-b border-gray-100 flex items-center justify-between" }
const _hoisted_12 = { class: "text-sm font-semibold text-[#22282F] flex items-center gap-2" }
const _hoisted_13 = { class: "text-xs text-gray-400" }
const _hoisted_14 = { class: "overflow-x-auto" }
const _hoisted_15 = { class: "flex items-stretch gap-0 p-5 min-w-max" }
const _hoisted_16 = { class: "w-72 shrink-0 border border-gray-200 rounded-xl p-4 flex flex-col gap-3 bg-gray-50/50" }
const _hoisted_17 = { class: "flex items-center justify-between" }
const _hoisted_18 = { class: "w-6 h-6 rounded-full bg-[#22282F] text-white text-xs font-bold flex items-center justify-center" }
const _hoisted_19 = { class: "flex items-center gap-1" }
const _hoisted_20 = ["disabled", "onClick"]
const _hoisted_21 = ["disabled", "onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "grid grid-cols-3 gap-1 bg-gray-100 rounded-lg p-1" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 0,
  class: "space-y-2"
}
const _hoisted_26 = ["onUpdate:modelValue", "onChange"]
const _hoisted_27 = ["value"]
const _hoisted_28 = ["onUpdate:modelValue"]
const _hoisted_29 = ["value"]
const _hoisted_30 = ["onUpdate:modelValue", "onChange"]
const _hoisted_31 = ["value"]
const _hoisted_32 = ["onUpdate:modelValue", "disabled"]
const _hoisted_33 = ["value"]
const _hoisted_34 = ["onUpdate:modelValue", "onChange"]
const _hoisted_35 = ["value"]
const _hoisted_36 = ["onUpdate:modelValue", "disabled", "onChange"]
const _hoisted_37 = ["value"]
const _hoisted_38 = ["onUpdate:modelValue", "disabled"]
const _hoisted_39 = ["value"]
const _hoisted_40 = ["onUpdate:modelValue"]
const _hoisted_41 = ["value"]
const _hoisted_42 = ["onUpdate:modelValue"]
const _hoisted_43 = ["value"]
const _hoisted_44 = {
  key: 1,
  class: "flex gap-2 bg-violet-50 border border-violet-100 rounded-lg p-2.5"
}
const _hoisted_45 = {
  key: 2,
  class: "space-y-2"
}
const _hoisted_46 = ["onUpdate:modelValue"]
const _hoisted_47 = ["value"]
const _hoisted_48 = { class: "flex gap-2 bg-amber-50 border border-amber-100 rounded-lg p-2.5" }
const _hoisted_49 = {
  key: 0,
  class: "flex gap-2 bg-blue-50 border border-blue-100 rounded-lg p-2.5"
}
const _hoisted_50 = { class: "pt-2 border-t border-gray-200 space-y-2" }
const _hoisted_51 = ["onUpdate:modelValue"]
const _hoisted_52 = ["value", "disabled"]
const _hoisted_53 = {
  key: 0,
  class: "flex items-center gap-2 cursor-pointer"
}
const _hoisted_54 = ["onUpdate:modelValue"]
const _hoisted_55 = { class: "flex items-center gap-4" }
const _hoisted_56 = { class: "flex items-center gap-1.5 cursor-pointer" }
const _hoisted_57 = ["onUpdate:modelValue"]
const _hoisted_58 = { class: "flex items-center gap-1.5 cursor-pointer" }
const _hoisted_59 = ["onUpdate:modelValue"]
const _hoisted_60 = {
  key: 0,
  class: "text-xs text-amber-600"
}
const _hoisted_61 = {
  key: 1,
  class: "text-[11px] text-gray-400 leading-snug"
}
const _hoisted_62 = {
  key: 0,
  class: "flex items-center justify-center w-10 shrink-0"
}
const _hoisted_63 = { class: "flex items-center pl-3" }
const _hoisted_64 = { class: "bg-white border border-gray-200 rounded-xl shadow-sm p-5" }
const _hoisted_65 = { class: "text-sm font-semibold text-[#22282F] flex items-center gap-2 mb-3" }
const _hoisted_66 = {
  key: 0,
  class: "text-sm text-gray-500 bg-gray-50 border border-gray-200 rounded-lg p-4"
}
const _hoisted_67 = { class: "flex gap-3 mb-4" }
const _hoisted_68 = ["value"]
const _hoisted_69 = ["disabled"]
const _hoisted_70 = {
  key: 0,
  class: "w-4 h-4 border-2 border-gray-300 border-t-[#22282F] rounded-full animate-spin"
}
const _hoisted_71 = {
  key: 0,
  class: "text-sm text-red-600 bg-red-50 border border-red-100 rounded-lg p-3"
}
const _hoisted_72 = {
  key: 1,
  class: "overflow-x-auto"
}
const _hoisted_73 = { class: "flex items-center gap-1.5 min-w-max py-1" }
const _hoisted_74 = { class: "flex flex-col items-start gap-0.5 px-3 py-2 rounded-lg text-xs font-medium whitespace-nowrap border bg-green-50 text-green-700 border-green-100" }
const _hoisted_75 = { class: "text-[10px] text-green-600/70 font-normal" }

import { ref, reactive, computed, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import {
  ArrowLeft, ArrowRight, ChevronLeft, ChevronRight, Plus, Trash2, Copy,
  Workflow, GitBranch, Shield, Eye, Info,
} from 'lucide-vue-next'
import AdminLayout from '@/layouts/AdminLayout.vue'
import { apiFetch } from '@/utils/apiFetch'
import { useToast } from '@/utils/toast'
import {
  ROLE_NATIONAL_OPTIONS, INSTRUCTION_TYPE_OPTIONS, TARGET_TYPE_OPTIONS,
  emptyStep, type WorkflowStep, type WorkflowTemplate, type StepKind,
} from '@/types/workflowTemplate'

interface Direction { id: number; code: string; nom: string }
interface Departement { id: number; nom: string; direction: { id: number } }
interface ServiceRef { id: number; nom: string; departement: { id: number } | null }
interface Ambassade { id: number; code: string; nom: string }
interface UserOption { id: number; full_name: string; role_label: string }


export default /*@__PURE__*/_defineComponent({
  __name: 'WorkflowTemplateBuilderView',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const toast = useToast()

const templateId = computed(() => {
  const id = route.params.id
  return id && id !== 'new' ? Number(id) : null
})

const loading = ref(true)
const saving = ref(false)
const directions = ref<Direction[]>([])
const departements = ref<Departement[]>([])
const services = ref<ServiceRef[]>([])
const ambassades = ref<Ambassade[]>([])
const users = ref<UserOption[]>([])

const form = reactive({ nom: '', description: '', is_active: true })
let stepKeySeq = 0
const steps = ref<(WorkflowStep & { _key: number; _directionFilter?: number | null; _departementFilter?: number | null })[]>([])

const kindOptions: { value: StepKind; label: string }[] = [
  { value: 'FIXED_ENTITY', label: 'Cible précise' },
  { value: 'HIERARCHIE_INITIATEUR', label: 'Hiérarchie dynamique' },
  { value: 'ROLE_NATIONAL', label: 'Rôle national' },
]

const departementsForDirection = (directionId?: number | null) =>
  directionId ? departements.value.filter(d => d.direction?.id === directionId) : []

const servicesForDepartement = (departementId?: number | null) =>
  departementId ? services.value.filter(s => s.departement?.id === departementId) : []

const directionIdOfDepartement = (departementId?: number | null) =>
  departements.value.find(d => d.id === departementId)?.direction?.id ?? null

const directionIdOfService = (serviceId?: number | null) => {
  const svc = services.value.find(s => s.id === serviceId)
  return svc ? directionIdOfDepartement(svc.departement?.id) : null
}

const fetchReferenceData = async () => {
  const [dirs, depts, svcs, ambs, usersRaw] = await Promise.all([
    apiFetch<any[]>('/api/admin/directions/'),
    apiFetch<any[]>('/api/admin/departements/'),
    apiFetch<any[]>('/api/admin/services/'),
    apiFetch<any[]>('/api/admin/ambassades/'),
    apiFetch<any[]>('/api/admin/users/'),
  ])
  directions.value = dirs
  departements.value = depts
  services.value = svcs
  ambassades.value = ambs
  users.value = usersRaw
    .map((u: any) => ({
      id: u.id,
      full_name: u.full_name || u.username || `Utilisateur #${u.id}`,
      role_label: u.profile?.role?.nom || u.role?.nom || 'Sans rôle',
    }))
    .sort((a, b) => a.full_name.localeCompare(b.full_name))
}

const hydrateStep = (raw: WorkflowStep): typeof steps.value[number] => {
  const step: typeof steps.value[number] = {
    ...raw,
    _key: stepKeySeq++,
    target_id: raw.target?.id ?? null,
    target_type: raw.target?.type ?? raw.target_type ?? (raw.kind === 'FIXED_ENTITY' ? 'DIRECTION' : null),
    _directionFilter: null,
    _departementFilter: null,
  }
  if (step.kind === 'FIXED_ENTITY' && step.target_type === 'DEPARTEMENT') {
    step._directionFilter = directionIdOfDepartement(step.target_id)
  }
  if (step.kind === 'FIXED_ENTITY' && step.target_type === 'SERVICE') {
    step._directionFilter = directionIdOfService(step.target_id)
    step._departementFilter = services.value.find(s => s.id === step.target_id)?.departement?.id ?? null
  }
  return step
}

const loadTemplate = async () => {
  if (!templateId.value) {
    steps.value = [hydrateStep(emptyStep(1))]
    return
  }
  const wt = await apiFetch<WorkflowTemplate>(`/api/admin/workflow-templates/${templateId.value}/`)
  form.nom = wt.nom
  form.description = wt.description
  form.is_active = wt.is_active
  steps.value = wt.steps.map(hydrateStep)
}

onMounted(async () => {
  try {
    await fetchReferenceData()
    await loadTemplate()
  } catch (e: any) {
    toast.error('Erreur', e.message || 'Impossible de charger les données')
  } finally {
    loading.value = false
  }
})

// ─── Édition des étapes ─────────────────────────────────────────────────

const addStep = () => {
  steps.value.push(hydrateStep(emptyStep(steps.value.length + 1)))
}

const removeStep = (idx: number) => {
  steps.value.splice(idx, 1)
}

const moveStep = (idx: number, dir: -1 | 1) => {
  const target = idx + dir
  if (target < 0 || target >= steps.value.length) return
  const [item] = steps.value.splice(idx, 1)
  steps.value.splice(target, 0, item)
}

const setKind = (step: typeof steps.value[number], kind: StepKind) => {
  step.kind = kind
  if (kind === 'HIERARCHIE_INITIATEUR' && step.instruction_type === 'ACTION_CONJOINTE') {
    step.instruction_type = 'ACTION'
  }
  if (kind !== 'FIXED_ENTITY') {
    step.target_type = null
    step.target_id = null
  } else if (!step.target_type) {
    step.target_type = 'DIRECTION'
  }
  if (kind !== 'ROLE_NATIONAL') {
    step.role_national_code = null
  }
}

const onTargetTypeChange = (step: typeof steps.value[number]) => {
  step.target_id = null
  step._directionFilter = null
  step._departementFilter = null
}

// ─── Sauvegarde ──────────────────────────────────────────────────────────

const validate = (): string | null => {
  if (!form.nom.trim()) return 'Le nom est obligatoire'
  if (!steps.value.length) return 'Le workflow doit contenir au moins une étape'
  for (const [i, step] of steps.value.entries()) {
    const n = i + 1
    if (step.kind === 'FIXED_ENTITY' && !step.target_id) return `Étape ${n} : choisissez une cible`
    if (step.kind === 'ROLE_NATIONAL' && !step.role_national_code) return `Étape ${n} : choisissez un rôle national`
  }
  // La dernière étape clôt toujours le circuit (PKI), que "Signature" soit
  // coché ou non — mais seulement si elle exige au moins "Paraphe". Sans ça,
  // plus personne ne clôture jamais le circuit (piège de configuration
  // silencieux), re-vérifié côté serveur dans tous les cas.
  const derniere = steps.value[steps.value.length - 1]
  if (!derniere.requires_paraphe) {
    return 'La dernière étape doit garder "Paraphe" coché (que "Signature" le soit ou non) — sinon personne ne clôture jamais le circuit.'
  }
  return null
}

const buildPayload = () => ({
  nom: form.nom.trim(),
  description: form.description.trim(),
  is_active: form.is_active,
  steps: steps.value.map((step, idx) => ({
    ordre: idx + 1,
    kind: step.kind,
    target_type: step.kind === 'FIXED_ENTITY' ? step.target_type : undefined,
    target_id: step.kind === 'FIXED_ENTITY' ? step.target_id : undefined,
    role_national_code: step.kind === 'ROLE_NATIONAL' ? step.role_national_code : undefined,
    instruction_type: step.instruction_type,
    is_principal: step.is_principal,
    requires_paraphe: step.requires_paraphe,
    requires_signature: step.requires_signature,
  })),
})

const save = async () => {
  const error = validate()
  if (error) {
    toast.error('Validation', error)
    return
  }
  saving.value = true
  try {
    const payload = buildPayload()
    const saved = templateId.value
      ? await apiFetch<WorkflowTemplate>(`/api/admin/workflow-templates/${templateId.value}/`, {
          method: 'PUT', body: JSON.stringify(payload),
        })
      : await apiFetch<WorkflowTemplate>('/api/admin/workflow-templates/', {
          method: 'POST', body: JSON.stringify(payload),
        })

    toast.success('Workflow enregistré', `« ${saved.nom} » a été sauvegardé`)
    steps.value = saved.steps.map(hydrateStep)
    if (!templateId.value) {
      router.replace(`/workflow-templates/${saved.id}`)
    }
  } catch (e: any) {
    toast.error('Erreur', e.message || "Impossible d'enregistrer le workflow")
  } finally {
    saving.value = false
  }
}

const doDuplicate = async () => {
  if (!templateId.value) return
  try {
    const clone = await apiFetch<WorkflowTemplate>(`/api/admin/workflow-templates/${templateId.value}/duplicate/`, { method: 'POST' })
    toast.success('Workflow dupliqué', `« ${clone.nom} » a été créé`)
    router.push(`/workflow-templates/${clone.id}`)
  } catch (e: any) {
    toast.error('Erreur', e.message || 'Impossible de dupliquer ce workflow')
  }
}

// ─── Aperçu ──────────────────────────────────────────────────────────────

const previewUserId = ref<number | null>(null)
const previewing = ref(false)
const previewError = ref('')
const previewResult = ref<{ initiator: string; items: any[] } | null>(null)

const runPreview = async () => {
  if (!templateId.value || !previewUserId.value) return
  previewing.value = true
  previewError.value = ''
  previewResult.value = null
  try {
    previewResult.value = await apiFetch(
      `/api/admin/workflow-templates/${templateId.value}/preview/?user_id=${previewUserId.value}`
    )
  } catch (e: any) {
    previewError.value = e.message || "Impossible de résoudre le circuit pour cet utilisateur"
  } finally {
    previewing.value = false
  }
}

const instructionLabel = (value: string) =>
  INSTRUCTION_TYPE_OPTIONS.find(o => o.value === value)?.label || value

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/workflow-templates'))),
            class: "p-2 hover:bg-gray-100 rounded-lg transition-colors shrink-0 mt-1",
            title: "Retour à la liste"
          }, [
            _createVNode(_unref(ArrowLeft), { class: "w-5 h-5 text-gray-500" })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _cache[5] || (_cache[5] = _createElementVNode("label", { class: "block text-xs font-medium text-gray-500 mb-1" }, [
                _createTextVNode("Nom du workflow "),
                _createElementVNode("span", { class: "text-red-500" }, "*")
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.nom) = $event)),
                type: "text",
                placeholder: "ex: Note à l'attention du SG",
                class: "w-full px-3 py-2 border border-gray-200 rounded-lg text-sm font-medium focus:outline-none focus:border-[#22282F] focus:ring-2 focus:ring-[#22282F]/20"
              }, null, 512), [
                [_vModelText, form.nom]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[6] || (_cache[6] = _createElementVNode("label", { class: "block text-xs font-medium text-gray-500 mb-1" }, "Description", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.description) = $event)),
                type: "text",
                placeholder: "Description optionnelle...",
                class: "w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-[#22282F] focus:ring-2 focus:ring-[#22282F]/20"
              }, null, 512), [
                [_vModelText, form.description]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("label", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.is_active) = $event)),
                class: "rounded"
              }, null, 512), [
                [_vModelCheckbox, form.is_active]
              ]),
              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-sm text-gray-700" }, "Actif", -1))
            ]),
            (templateId.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: doDuplicate,
                  class: "p-2.5 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors",
                  title: "Dupliquer ce workflow"
                }, [
                  _createVNode(_unref(Copy), { class: "w-4 h-4 text-gray-500" })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              onClick: save,
              disabled: saving.value,
              class: "px-4 py-2.5 bg-[#22282F] text-white rounded-lg text-sm hover:bg-[#22282F]/90 transition-colors disabled:opacity-50 flex items-center gap-2"
            }, [
              (saving.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7))
                : _createCommentVNode("", true),
              _cache[8] || (_cache[8] = _createTextVNode(" Enregistrer "))
            ], 8, _hoisted_6)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[9] || (_cache[9] = [
              _createElementVNode("div", { class: "w-8 h-8 border-4 border-gray-200 border-t-[#22282F] rounded-full animate-spin" }, null, -1)
            ])))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("h3", _hoisted_12, [
                    _createVNode(_unref(Workflow), { class: "w-4 h-4 text-gray-400" }),
                    _cache[10] || (_cache[10] = _createTextVNode(" Étapes du circuit "))
                  ]),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(steps.value.length) + " étape(s) · faites défiler horizontalement →", 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(steps.value, (step, idx) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: step._key
                      }, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("span", _hoisted_18, _toDisplayString(idx + 1), 1),
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("button", {
                                disabled: idx === 0,
                                onClick: ($event: any) => (moveStep(idx, -1)),
                                class: "p-1.5 rounded hover:bg-gray-200 disabled:opacity-30 disabled:hover:bg-transparent",
                                title: "Déplacer vers la gauche"
                              }, [
                                _createVNode(_unref(ChevronLeft), { class: "w-4 h-4 text-gray-500" })
                              ], 8, _hoisted_20),
                              _createElementVNode("button", {
                                disabled: idx === steps.value.length - 1,
                                onClick: ($event: any) => (moveStep(idx, 1)),
                                class: "p-1.5 rounded hover:bg-gray-200 disabled:opacity-30 disabled:hover:bg-transparent",
                                title: "Déplacer vers la droite"
                              }, [
                                _createVNode(_unref(ChevronRight), { class: "w-4 h-4 text-gray-500" })
                              ], 8, _hoisted_21),
                              _createElementVNode("button", {
                                onClick: ($event: any) => (removeStep(idx)),
                                class: "p-1.5 rounded hover:bg-red-50",
                                title: "Retirer l'étape"
                              }, [
                                _createVNode(_unref(Trash2), { class: "w-4 h-4 text-red-400" })
                              ], 8, _hoisted_22)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(kindOptions, (opt) => {
                              return _createElementVNode("button", {
                                key: opt.value,
                                onClick: ($event: any) => (setKind(step, opt.value)),
                                class: _normalizeClass([
                        'py-1.5 rounded-md text-[11px] font-medium transition-colors leading-tight',
                        step.kind === opt.value ? 'bg-white text-[#22282F] shadow-sm' : 'text-gray-500 hover:text-gray-700'
                      ])
                              }, _toDisplayString(opt.label), 11, _hoisted_24)
                            }), 64))
                          ]),
                          (step.kind === 'FIXED_ENTITY')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                _withDirectives(_createElementVNode("select", {
                                  "onUpdate:modelValue": ($event: any) => ((step.target_type) = $event),
                                  onChange: ($event: any) => (onTargetTypeChange(step)),
                                  class: "w-full px-2.5 py-2 border border-gray-200 rounded-lg text-xs bg-white focus:outline-none focus:border-[#22282F]"
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(TARGET_TYPE_OPTIONS), (t) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: t.value,
                                      value: t.value
                                    }, _toDisplayString(t.label), 9, _hoisted_27))
                                  }), 128))
                                ], 40, _hoisted_26), [
                                  [_vModelSelect, step.target_type]
                                ]),
                                (step.target_type === 'DIRECTION')
                                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                      key: 0,
                                      "onUpdate:modelValue": ($event: any) => ((step.target_id) = $event),
                                      class: "w-full px-2.5 py-2 border border-gray-200 rounded-lg text-xs bg-white focus:outline-none focus:border-[#22282F]"
                                    }, [
                                      _cache[11] || (_cache[11] = _createElementVNode("option", { value: null }, "-- Choisir --", -1)),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(directions.value, (d) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          key: d.id,
                                          value: d.id
                                        }, _toDisplayString(d.code) + " — " + _toDisplayString(d.nom), 9, _hoisted_29))
                                      }), 128))
                                    ], 8, _hoisted_28)), [
                                      [
                                        _vModelSelect,
                                        step.target_id,
                                        void 0,
                                        { number: true }
                                      ]
                                    ])
                                  : _createCommentVNode("", true),
                                (step.target_type === 'DEPARTEMENT')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _withDirectives(_createElementVNode("select", {
                                        "onUpdate:modelValue": ($event: any) => ((step._directionFilter) = $event),
                                        onChange: ($event: any) => (step.target_id = null),
                                        class: "w-full px-2.5 py-2 border border-gray-200 rounded-lg text-xs bg-white focus:outline-none focus:border-[#22282F]"
                                      }, [
                                        _cache[12] || (_cache[12] = _createElementVNode("option", { value: null }, "-- Direction --", -1)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(directions.value, (d) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: d.id,
                                            value: d.id
                                          }, _toDisplayString(d.code) + " — " + _toDisplayString(d.nom), 9, _hoisted_31))
                                        }), 128))
                                      ], 40, _hoisted_30), [
                                        [
                                          _vModelSelect,
                                          step._directionFilter,
                                          void 0,
                                          { number: true }
                                        ]
                                      ]),
                                      _withDirectives(_createElementVNode("select", {
                                        "onUpdate:modelValue": ($event: any) => ((step.target_id) = $event),
                                        disabled: !step._directionFilter,
                                        class: "w-full px-2.5 py-2 border border-gray-200 rounded-lg text-xs bg-white focus:outline-none focus:border-[#22282F] disabled:bg-gray-100"
                                      }, [
                                        _cache[13] || (_cache[13] = _createElementVNode("option", { value: null }, "-- Département --", -1)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(departementsForDirection(step._directionFilter), (d) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: d.id,
                                            value: d.id
                                          }, _toDisplayString(d.nom), 9, _hoisted_33))
                                        }), 128))
                                      ], 8, _hoisted_32), [
                                        [
                                          _vModelSelect,
                                          step.target_id,
                                          void 0,
                                          { number: true }
                                        ]
                                      ])
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (step.target_type === 'SERVICE')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                      _withDirectives(_createElementVNode("select", {
                                        "onUpdate:modelValue": ($event: any) => ((step._directionFilter) = $event),
                                        onChange: ($event: any) => {step._departementFilter = null; step.target_id = null},
                                        class: "w-full px-2.5 py-2 border border-gray-200 rounded-lg text-xs bg-white focus:outline-none focus:border-[#22282F]"
                                      }, [
                                        _cache[14] || (_cache[14] = _createElementVNode("option", { value: null }, "-- Direction --", -1)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(directions.value, (d) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: d.id,
                                            value: d.id
                                          }, _toDisplayString(d.code) + " — " + _toDisplayString(d.nom), 9, _hoisted_35))
                                        }), 128))
                                      ], 40, _hoisted_34), [
                                        [
                                          _vModelSelect,
                                          step._directionFilter,
                                          void 0,
                                          { number: true }
                                        ]
                                      ]),
                                      _withDirectives(_createElementVNode("select", {
                                        "onUpdate:modelValue": ($event: any) => ((step._departementFilter) = $event),
                                        disabled: !step._directionFilter,
                                        onChange: ($event: any) => (step.target_id = null),
                                        class: "w-full px-2.5 py-2 border border-gray-200 rounded-lg text-xs bg-white focus:outline-none focus:border-[#22282F] disabled:bg-gray-100"
                                      }, [
                                        _cache[15] || (_cache[15] = _createElementVNode("option", { value: null }, "-- Département --", -1)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(departementsForDirection(step._directionFilter), (d) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: d.id,
                                            value: d.id
                                          }, _toDisplayString(d.nom), 9, _hoisted_37))
                                        }), 128))
                                      ], 40, _hoisted_36), [
                                        [
                                          _vModelSelect,
                                          step._departementFilter,
                                          void 0,
                                          { number: true }
                                        ]
                                      ]),
                                      _withDirectives(_createElementVNode("select", {
                                        "onUpdate:modelValue": ($event: any) => ((step.target_id) = $event),
                                        disabled: !step._departementFilter,
                                        class: "w-full px-2.5 py-2 border border-gray-200 rounded-lg text-xs bg-white focus:outline-none focus:border-[#22282F] disabled:bg-gray-100"
                                      }, [
                                        _cache[16] || (_cache[16] = _createElementVNode("option", { value: null }, "-- Service --", -1)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(servicesForDepartement(step._departementFilter), (s) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: s.id,
                                            value: s.id
                                          }, _toDisplayString(s.nom), 9, _hoisted_39))
                                        }), 128))
                                      ], 8, _hoisted_38), [
                                        [
                                          _vModelSelect,
                                          step.target_id,
                                          void 0,
                                          { number: true }
                                        ]
                                      ])
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (step.target_type === 'AMBASSADE')
                                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                      key: 3,
                                      "onUpdate:modelValue": ($event: any) => ((step.target_id) = $event),
                                      class: "w-full px-2.5 py-2 border border-gray-200 rounded-lg text-xs bg-white focus:outline-none focus:border-[#22282F]"
                                    }, [
                                      _cache[17] || (_cache[17] = _createElementVNode("option", { value: null }, "-- Choisir --", -1)),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ambassades.value, (a) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          key: a.id,
                                          value: a.id
                                        }, _toDisplayString(a.code) + " — " + _toDisplayString(a.nom), 9, _hoisted_41))
                                      }), 128))
                                    ], 8, _hoisted_40)), [
                                      [
                                        _vModelSelect,
                                        step.target_id,
                                        void 0,
                                        { number: true }
                                      ]
                                    ])
                                  : _createCommentVNode("", true),
                                (step.target_type === 'USER')
                                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                      key: 4,
                                      "onUpdate:modelValue": ($event: any) => ((step.target_id) = $event),
                                      class: "w-full px-2.5 py-2 border border-gray-200 rounded-lg text-xs bg-white focus:outline-none focus:border-[#22282F]"
                                    }, [
                                      _cache[18] || (_cache[18] = _createElementVNode("option", { value: null }, "-- Choisir --", -1)),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(users.value, (u) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          key: u.id,
                                          value: u.id
                                        }, _toDisplayString(u.full_name) + " (" + _toDisplayString(u.role_label) + ")", 9, _hoisted_43))
                                      }), 128))
                                    ], 8, _hoisted_42)), [
                                      [
                                        _vModelSelect,
                                        step.target_id,
                                        void 0,
                                        { number: true }
                                      ]
                                    ])
                                  : _createCommentVNode("", true)
                              ]))
                            : (step.kind === 'HIERARCHIE_INITIATEUR')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                  _createVNode(_unref(GitBranch), { class: "w-4 h-4 text-violet-500 shrink-0 mt-0.5" }),
                                  _cache[19] || (_cache[19] = _createElementVNode("p", { class: "text-[11px] text-violet-700 leading-snug" }, " Au moment de la rédaction, remonte automatiquement du rédacteur jusqu'à son plafond (Directeur, DC ou Ambassadeur/Chargé d'Affaires selon son rattachement). S'adapte à n'importe quel initiateur — aucune cible à choisir ici. ", -1))
                                ]))
                              : (step.kind === 'ROLE_NATIONAL')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                    _withDirectives(_createElementVNode("select", {
                                      "onUpdate:modelValue": ($event: any) => ((step.role_national_code) = $event),
                                      class: "w-full px-2.5 py-2 border border-gray-200 rounded-lg text-xs bg-white focus:outline-none focus:border-[#22282F]"
                                    }, [
                                      _cache[20] || (_cache[20] = _createElementVNode("option", { value: null }, "-- Choisir un rôle --", -1)),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ROLE_NATIONAL_OPTIONS), (r) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          key: r.code,
                                          value: r.code
                                        }, _toDisplayString(r.label), 9, _hoisted_47))
                                      }), 128))
                                    ], 8, _hoisted_46), [
                                      [_vModelSelect, step.role_national_code]
                                    ]),
                                    _createElementVNode("div", _hoisted_48, [
                                      _createVNode(_unref(Shield), { class: "w-4 h-4 text-amber-500 shrink-0 mt-0.5" }),
                                      _cache[21] || (_cache[21] = _createElementVNode("p", { class: "text-[11px] text-amber-700 leading-snug" }, " Résolu par rôle, pas par personne : reste valide après un changement de titulaire. ", -1))
                                    ]),
                                    (step.role_national_code === 'ASSISTANT_SGA' || step.role_national_code === 'SGA')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                          _createVNode(_unref(Info), { class: "w-4 h-4 text-blue-500 shrink-0 mt-0.5" }),
                                          _cache[22] || (_cache[22] = _createElementVNode("p", { class: "text-[11px] text-blue-700 leading-snug" }, " Si le SG a désactivé le relais obligatoire (réglage global), cette étape est automatiquement court-circuitée et le circuit va directement au SG. ", -1))
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_50, [
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": ($event: any) => ((step.instruction_type) = $event),
                              class: "w-full px-2.5 py-2 border border-gray-200 rounded-lg text-xs bg-white focus:outline-none focus:border-[#22282F]"
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(INSTRUCTION_TYPE_OPTIONS), (opt) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: opt.value,
                                  value: opt.value,
                                  disabled: opt.value === 'ACTION_CONJOINTE' && step.kind === 'HIERARCHIE_INITIATEUR'
                                }, _toDisplayString(opt.label), 9, _hoisted_52))
                              }), 128))
                            ], 8, _hoisted_51), [
                              [_vModelSelect, step.instruction_type]
                            ]),
                            (step.instruction_type === 'ACTION_CONJOINTE')
                              ? (_openBlock(), _createElementBlock("label", _hoisted_53, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    "onUpdate:modelValue": ($event: any) => ((step.is_principal) = $event),
                                    class: "rounded"
                                  }, null, 8, _hoisted_54), [
                                    [_vModelCheckbox, step.is_principal]
                                  ]),
                                  _cache[23] || (_cache[23] = _createElementVNode("span", { class: "text-xs text-gray-600" }, "Porteur principal du groupe", -1))
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_55, [
                              _createElementVNode("label", _hoisted_56, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": ($event: any) => ((step.requires_paraphe) = $event),
                                  class: "rounded"
                                }, null, 8, _hoisted_57), [
                                  [_vModelCheckbox, step.requires_paraphe]
                                ]),
                                _cache[24] || (_cache[24] = _createElementVNode("span", { class: "text-xs text-gray-600" }, "Paraphe", -1))
                              ]),
                              _createElementVNode("label", _hoisted_58, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": ($event: any) => ((step.requires_signature) = $event),
                                  class: "rounded"
                                }, null, 8, _hoisted_59), [
                                  [_vModelCheckbox, step.requires_signature]
                                ]),
                                _cache[25] || (_cache[25] = _createElementVNode("span", { class: "text-xs text-gray-600" }, "Signature", -1))
                              ]),
                              (idx === steps.value.length - 1 && !step.requires_paraphe)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_60, " ⚠ Cette étape clôt le circuit (PKI) : « Paraphe » doit rester coché. "))
                                : _createCommentVNode("", true)
                            ]),
                            (idx === steps.value.length - 1)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_61, " La dernière étape clôt toujours le circuit (PKI), que « Signature » soit coché ou non. « Signature » n'ajoute qu'un tampon visuel — cochez-le, ici ou sur une étape précédente, uniquement si cette personne doit apposer sa propre signature sur le document. "))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        (idx < steps.value.length - 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                              _createVNode(_unref(ArrowRight), { class: "w-5 h-5 text-gray-300" })
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128)),
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("button", {
                        onClick: addStep,
                        class: "w-16 h-16 rounded-xl border-2 border-dashed border-gray-300 hover:border-[#22282F] hover:bg-gray-50 transition-colors flex items-center justify-center shrink-0",
                        title: "Ajouter une étape"
                      }, [
                        _createVNode(_unref(Plus), { class: "w-6 h-6 text-gray-400" })
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("h3", _hoisted_65, [
                  _createVNode(_unref(Eye), { class: "w-4 h-4 text-gray-400" }),
                  _cache[26] || (_cache[26] = _createTextVNode(" Aperçu pour un initiateur donné "))
                ]),
                (!templateId.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_66, " Enregistrez d'abord le workflow pour activer l'aperçu. "))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_67, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((previewUserId).value = $event)),
                          class: "flex-1 px-3 py-2.5 border border-gray-200 rounded-lg text-sm bg-white focus:outline-none focus:border-[#22282F]"
                        }, [
                          _cache[27] || (_cache[27] = _createElementVNode("option", { value: null }, "-- Choisir un utilisateur pour simuler la rédaction --", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(users.value, (u) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: u.id,
                              value: u.id
                            }, _toDisplayString(u.full_name) + " (" + _toDisplayString(u.role_label) + ")", 9, _hoisted_68))
                          }), 128))
                        ], 512), [
                          [
                            _vModelSelect,
                            previewUserId.value,
                            void 0,
                            { number: true }
                          ]
                        ]),
                        _createElementVNode("button", {
                          onClick: runPreview,
                          disabled: !previewUserId.value || previewing.value,
                          class: "px-4 py-2.5 border border-gray-200 rounded-lg text-sm hover:bg-gray-50 transition-colors disabled:opacity-50 flex items-center gap-2 shrink-0"
                        }, [
                          (previewing.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_70))
                            : _createCommentVNode("", true),
                          _cache[28] || (_cache[28] = _createTextVNode(" Prévisualiser "))
                        ], 8, _hoisted_69)
                      ]),
                      (previewError.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_71, _toDisplayString(previewError.value), 1))
                        : (previewResult.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                              _createElementVNode("div", _hoisted_73, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(previewResult.value.items, (item, idx) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
                                    _createElementVNode("div", _hoisted_74, [
                                      _createElementVNode("span", null, _toDisplayString(item.target_label), 1),
                                      _createElementVNode("span", _hoisted_75, _toDisplayString(instructionLabel(item.instruction_type)), 1)
                                    ]),
                                    (idx < previewResult.value.items.length - 1)
                                      ? (_openBlock(), _createBlock(_unref(ArrowRight), {
                                          key: 0,
                                          class: "w-4 h-4 text-gray-300 shrink-0"
                                        }))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                    ], 64))
              ])
            ], 64))
      ])
    ]),
    _: 1
  }))
}
}

})